import React from 'react'
import { Text } from '@afterpaytouch/core'
import type { GiftCardPromoBreakdown as GiftCardPromoBreakdownData } from '../../state'
import { useCheckoutSizes } from '../../utils/responsive'
import { useTranslation } from '../../utils/convergence'
import { Money, MoneyPrefix } from '../Money'
import { TrackingEvent } from '../../model/monitoring'
import { useLogGiftCardPromoViewOnce } from '../GiftCardPromoTracking'
import styles from './style.module.css'

interface GiftCardPromoBreakdownProps {
  promotion: GiftCardPromoBreakdownData
  purchaseAmountLabel?: string
  loading?: boolean
}

export const GiftCardPromoBreakdown = ({ promotion, purchaseAmountLabel, loading = false }: GiftCardPromoBreakdownProps): JSX.Element => {
  const { t } = useTranslation(['summary'])
  const { textSize } = useCheckoutSizes()
  useLogGiftCardPromoViewOnce(TrackingEvent.VIEWED_GIFT_CARD_PROMOTION_BREAKDOWN, loading ? null : promotion.trackingProperties ?? {})
  const rows = [
    { label: t('summary:giftCardPromotion.faceValue', { context: 'default' }), amount: promotion.faceValue, namespace: 'gift-card-face-value' },
    {
      label: t('summary:giftCardPromotion.discount', { context: 'default', displayName: promotion.displayName, interpolation: { escapeValue: false } }),
      amount: promotion.discountAmount,
      namespace: 'gift-card-promotion-discount',
      prefix: MoneyPrefix.NEGATIVE,
    },
    {
      label: purchaseAmountLabel ?? t('summary:giftCardPromotion.purchaseAmount', { context: 'default' }),
      amount: promotion.purchaseAmount,
      namespace: 'gift-card-purchase-amount',
    },
  ]

  return (
    <dl className={styles.breakdown} aria-label={t('summary:giftCardPromotion.label', { context: 'default' })}>
      {rows.map(({ label, amount, namespace, prefix }) => (
        <div className={styles.row} key={namespace}>
          <dt>
            <Text renderAs='span' size={textSize} color='Standard'>
              {label}
            </Text>
          </dt>
          <dd>
            <Money value={amount} size={textSize} color='Standard' prefix={prefix} loading={loading} testNameSpace={namespace} />
          </dd>
        </div>
      ))}
    </dl>
  )
}
